// extracted by mini-css-extract-plugin
module.exports = {"link-large":"LinkText_link-large__N8jHX","link-medium":"LinkText_link-medium__rwrij","link-small":"LinkText_link-small__a3UVS","link-wrapper":"LinkText_link-wrapper__8hSbf"};